/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useDisciplinesList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const DisciplineSelect = ({ placeholder = 'Type the name of discipline...', ...props }) => (
  <SearchableEntitySelect placeholder={placeholder} useList={useDisciplinesList} {...props} />
);

export default DisciplineSelect;
